import React from 'react'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import { Container, Button } from 'reactstrap'

const isValidUrl = (string) => {
	try {
		if(string.indexOf("http://") === 0 || string.indexOf("https://") === 0){
			return true
		}
	}
	catch{
		return false
	}
	return false
}

const HomeBannerLink = ( { link , children} ) => {
	if(isValidUrl(link)) return(
		<a href={link} className="d-block block-homebanner">
			{ children }
		</a>
	)

	return(
		<Link to={link} className="d-block block-homebanner">
			{ children }
		</Link>	
	)
}

const HomeBanner = ({attrs = {}, images = []}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		link: attrs?.link || '#',
		category: attrs?.category || null,
		title: attrs?.title || 'Bannière d\'accueil',
		subtitle: attrs?.subtitle || null,
		buttonlabel: attrs?.buttonlabel || null,
		mediaId: attrs?.mediaId || null,
		mediaMobileId: attrs?.mediaMobileId || null
	}

	// Vérification que images est un tableau
	const safeImages = Array.isArray(images) ? images : []

	const image = safeAttrs.mediaId && safeImages.find(({wordpress_id}) => wordpress_id === safeAttrs.mediaId)
	const imageSharpSizes = image && image.localFile && image.localFile.childImageSharp && image.localFile.childImageSharp.sizes
	// Récupérer l'alt text de l'image WordPress, avec fallback sur le titre de l'image puis le titre du banner
	const imageAlt = image?.alt_text || image?.title || safeAttrs.title

	const imageMobile = safeAttrs.mediaMobileId && safeImages.find(({wordpress_id}) => wordpress_id === safeAttrs.mediaMobileId)
	const imageMobileSharpSizes = imageMobile && imageMobile.localFile && imageMobile.localFile.childImageSharp && imageMobile && imageMobile.localFile && imageMobile.localFile.childImageSharp.sizes
	// Récupérer l'alt text de l'image mobile WordPress, avec fallback sur le titre de l'image puis le titre du banner
	const imageMobileAlt = imageMobile?.alt_text || imageMobile?.title || safeAttrs.title

	return(
		<>
			{safeAttrs.title ? (
				<HomeBannerLink link={safeAttrs.link}>
					<div className="content-wrapper">
						<Container className="h-100 position-relative content-container">
							<div className="content">
								{ safeAttrs.category && <span className="category">{safeAttrs.category}</span> }
								<h1 className="title">{safeAttrs.title}
									{ safeAttrs.subtitle && <span className="subtitle">{safeAttrs.subtitle}</span> }
								</h1>
								{ safeAttrs.buttonlabel && <Button className="banner-button">{ safeAttrs.buttonlabel }</Button> }	
							</div>
						</Container>
					</div>

					<div className="d-none d-sm-block background-image">
						{imageSharpSizes && <Img sizes={imageSharpSizes} alt={imageAlt} />}
					</div>

					<div className="d-block d-sm-none background-image">
						{imageMobileSharpSizes && <Img sizes={imageMobileSharpSizes} alt={imageMobileAlt} />}
					</div>
				</HomeBannerLink>
			) : (
				<div className="block-homebanner">
					<div className="background-image placeholder">
						<div className="placeholder-image" />
					</div>
				</div>
			)}
		</>
	)
}

export default HomeBanner
